<template>
  <div>
    <div class="card card-header list-group-item list-group-item-action active mb-3">
      <h4 class="mb-0">Cadastro de mãos de obras</h4>
    </div>
    <div class="card">
         
      <div style="padding:15px;">
          <vs-table
            :data="content">
            <template slot="header" >
              <h3>
                Registros
              </h3>
            </template>
            <template slot="thead">
              <vs-th :style="'width:'+iconArea+'px'">
                Registros
              </vs-th>
              <vs-th>
                Nome
              </vs-th>
              <vs-th style="width:150px;">
                CPF
              </vs-th>
              <vs-th style="width:150px;">
                Salário
              </vs-th>
              <vs-th style="width:150px;">
                Décimo terceiro
              </vs-th>
             <vs-th style="width:45px;">
                Regime de contratação
              </vs-th>
             <vs-th style="width:45px;">
                Aprovar
            </vs-th>                
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
              <vs-td>
                <a
                class="icone-editar"
                data-editar
                title="Funções"

                @click="fnFuncoes(tr.etapaId)"
                >
                  <i class="i-circled i-small i-light icon-briefcase1"></i>
                </a>
                  <a
                  class="icone-editar"
                  data-editar
                  title="Benefícios"

                  @click="fnBeneficios(tr.etapaId)"
                  >
                    <i class="i-circled i-small i-light icon-credit-cards"></i>
                  </a>
                  </vs-td>
                <vs-td :data="tr.nome">
                  {{tr.nome}}
                </vs-td>

                <vs-td :data="tr.cpf">
                  {{tr.cpf}}
                </vs-td>
                <vs-td :data="tr.salario">
                 R$ {{formataPrice(tr.salario)}}
                </vs-td>
                <vs-td :data="tr.salario">
                 R$ {{formataPrice(tr.decimoTerceiro)}}
                </vs-td>
                 <vs-td :data="tr.regimeId">
                  {{fnConcat(tr.regimeId)}}
                </vs-td>
               <vs-td class="text-center">
                  <a
                  class="icone-editar"
                  data-editar
                  title="Benefícios"
                  v-if="!tr.aprovada"
                  @click="fnAprova(tr.etapaId)"
                  >
                    <i class="i-circled i-small i-light"
                    :class="'icon-flag-checkered1'"
                    :style="'background:#8fc4a5;'"
                    ></i>
                  </a>                  
                  <a
                  class="icone-editar"
                  data-editar
                  title="Benefícios"
                  v-else
                  >
                    <i class="i-circled i-small i-light"
                    :class="'icon-checkbox-checked'"
                    :style="'background:#ccc; color:#888'"
                    ></i>
                  </a>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
  import { getSuccess,formatPrice } from "../../../../global/utils";

  export default {
    data() {
      return {
        content:[],
        cadastro:{
        } ,
        regimes:{},
        incluindo:false,
        iconArea: 48 * 2,
        titulo:'',
        tipo:'',
        cadastroid:null
      }
    },
    mounted() {
      this.fnGetContratacao()
      this.fnGetRegimes()
    },
    methods: {
      async fnGetRegimes(){
        await this.$http.get('listaregimescontratacao/api/')
        .then(res=> {
          this.regimes = res.data
        })
        .catch(()=>{})
    },
    formataPrice(val){
      return formatPrice(val)
    },
      async fnAprova(etapaId) {
        const metodo = "put"
        let dados = {
          aprovada: true,
          tsAprovacao: this.$moment().format(),
          EtapaId: etapaId,
          contratacaoId: this.cadastroid
        }
        await this.$http[metodo]("/etapa_05/aprova/" +etapaId, dados)
          .then(() => {
            getSuccess();
             this.fnGetContratacao()
          })
          .catch(() => {});
      },    

      async fnGetContratacao() {
        await this.$http
          .get(`contratacao/codigo/${this.$route.params.codigoContrato}/etapa_05`)
          .then((res) => {
            console.log(res.data.contratacaoId);
            this.cadastro.contratacaoId = res.data.contratacaoId;
            this.cadastroid = res.data.contratacaoId
            console.log(res.data.contratacoesEVO05);
            console.log(res.data.contratacoesEVO05 != null);
            if(res.data.contratacoesEVO05 != null){
               this.content = null
               this.content =[]
              var toString = JSON.stringify(res.data.contratacoesEVO05)
               var toJson = JSON.parse(toString)
              for(var i =0; i < toJson.length;i++){
                this.content.push(toJson[i])
              }
            }
          })
          .catch(() => {});
      },
      fnCancela(){
        this.incluindo = false;
        this.titulo = ''
        this.tipo =''

      },
      fnEdicao(val){
        if (val == 'Incluindo'){
          this.incluindo = true;
          this.titulo = 'Incluindo novo registro'
          this.tipo ='Inclusão'
        }
      },
      fnEditar(i){
       this.cadastro = this.content[i]
        },
      fnConcat(val){
        var item = this.regimes.filter((administracoes) => {
          return administracoes.regimeId ==val
        });
        var toString = JSON.stringify(item)
        var toJson = JSON.parse(toString)
        return toJson[0].titulo
    },
    fnFuncoes(val){
      this.$router.push({path:`/paineldegerenciamento/contrato/etapa5/${this.$route.params.codigoContrato}/funcoes/${val}`})
    },
    fnBeneficios(val){
      this.$router.push({path:`/paineldegerenciamento/contrato/etapa5/${this.$route.params.codigoContrato}/beneficios/${val}`})
    },
        convertToken(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    
        return JSON.parse(jsonPayload);
        },
    },
  }
</script>

<style lang="scss" scoped>
.card-header {
  h4 {
    color: #fff;
    text-align: center;
  }
}
.expand-user{
  width: 100%;
}
</style>